/**
 * JSON Schema for the main object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/MediaItem",
  type: "object",
  properties: {
    origin: { type: "string" },
    media_id: { type: "string" },
    module_id: { type: "string" },
    page_link: { type: "string" }
  },
  required: ["origin", "media_id"]
};
